<template>
  <div class="mgt-20px">
    <div class="card">
      <header class="header-card">
        <p>{{ $t('editionDemandeImpression.infoGenerale.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <b-field class="column is-8"
            :label="$t('editionDemandeImpression.infoGenerale.campagne')">
            <b-autocomplete
              v-model="campagne"
              :placeholder="$t('editionDemandeImpression.infoGenerale.campagne')"
              :data="campagnes"
              field="libelle"
              :loading="isFetchingCampagne"
              :open-on-focus="true"
              icon="magnify"
              @input="getCampagnesDebounce"
              @select="option =>
                demandeImpression.campagneId = option ? option.id : null">
              <template #header>
                <a
                  @click.stop="actionAddCampagne()"
                  :class="[
                    {'text-access-no-permission': !checkPermMajForCampagne},
                    {'pointer-events-none': !checkPermMajForCampagne},
                  ]"
                  class="lien is-inline-block">
                  {{ $t('editionDemandeImpression.actions.addCampagne') }}
                </a>
              </template>
              <template #empty>
                {{$t(`general.autocomplete.${!isFetchingCampagne
                  ? 'noRslt' : 'search'}`)}}
              </template>
              <template slot-scope="props">
                <div class="columns is-vcentered">
                    <div class="column is-8 is-prewrap">
                        {{ props.option.libelle }}
                    </div>
                    <div class="column is-4 has-text-right"
                      v-if="props.option.urlLogoCampagne">
                      <div class="max-height-img-view-80">
                        <img :src="props.option.urlLogoCampagne"
                          class="max-width-100 max-height-80">
                      </div>
                    </div>
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { getAll as getAllCampagnes } from '@/api/campagne';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { CAMPAGNE } from '@/configuration/permissionsBodacConf';
import { SET_DEMANDE_IMPRESSION } from '@/store/modules/logistique/demandeImpression-mutation-type';

const Societe = createNamespacedHelpers('societe');
const Permissions = createNamespacedHelpers('permissions');
const DemandeImpression = createNamespacedHelpers('demandeImpression');

export default {
  name: 'edition_campagne',
  props: {
    demandeImpression: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      campagnes: [],
      search: null,
      isFetchingCampagne: false,
      campagne: null,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    checkPermMajForCampagne() {
      return this.checkPermissions(CAMPAGNE.maj);
    },
  },
  methods: {
    ...DemandeImpression.mapMutations({
      setDemandeImpression: SET_DEMANDE_IMPRESSION,
    }),
    actionAddCampagne() {
      if (!this.checkPermMajForCampagne) {
        this.showPopUp();
        return;
      }
      this.setDemandeImpression(this.demandeImpression);
      this.$router.push({ name: 'm.bodac.campagne-add' });
    },
    getCampagnesDebounce: debounce(async function getCampagne(search) {
      if (search === '') {
        this.campagne = '';
        this.demandeImpression.campagneId = null;
      }
      let marquesIds = [];
      if (this.demandeImpression.client && this.demandeImpression.client.tiersMarques) {
        marquesIds = this.demandeImpression.client.tiersMarques.map(marque => marque.marqueId);
      }
      try {
        this.isFetchingCampagne = true;
        this.campagnes = (await getAllCampagnes({
          query: {
            auto: search,
            societeId: this.societeActiveId,
            actif: true,
            marqueIds: marquesIds,
            avecLogo: true,
          },
        })).data.result.items;
        this.isFetchingCampagne = false;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        this.isFetchingCampagne = false;
      }
    }, 300),
  },
  mounted() {
    this.campagne = this.demandeImpression.campagne?.libelle ?? '';
  },
};
</script>
